module.exports = __webpack_public_path__ + "static/media/explore.e376180c.png";